<template>
  <div>
    <el-row :gutter="16" type="flex" >
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期">
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="dataScope">
          <el-radio-button label="所有数据" ></el-radio-button>
          <el-radio-button label="只看新增" ></el-radio-button>
        </el-radio-group>
      </el-col>
<!--      <el-col :span="4">-->
<!--        <el-input v-model="keyword" clearable placeholder="输入检索词">-->
<!--        </el-input>-->
<!--      </el-col>-->
      <el-col :span="4" >
        <el-button icon="el-icon-search" @click="searchPageData"
        >搜索</el-button
        >
        <el-button icon="el-icon-download" @click="exportSelectedData" alt=""
        >下载</el-button
        >
      </el-col>

    </el-row>

    <el-row style="padding-top: 16px">
      <el-pagination
          background
          @current-change="queryGoodsPage"
          layout="total, prev, pager, next"
          :total="totalItems"
          :page-size="pageSize"
      >
      </el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
          ref="dataTable"
          :data="advs"
          style="width: 100%"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="searchKeyword" label="日期/关键词/guojia ">
          <template scope="scope">
            {{ scope.row.crawlerVersion }}
            /{{ scope.row.keyword }}
              /{{scope.row.region}}
          </template>
        </el-table-column>
        <el-table-column prop="goodsTitle" label="标题"></el-table-column>
        <el-table-column prop="goodsLink" label="商品链接"></el-table-column>
        <el-table-column prop="goodsCurrentPrice" label="商品价格"></el-table-column>
        <el-table-column prop="goodsSoldCount" label="商品销量"></el-table-column>
<!--        <el-table-column prop="uploadMainImages" label="图片">-->
<!--          <template scope="scope">-->
<!--            <el-carousel trigger="click" height="150px">-->
<!--              <el-carousel-item v-for="item in scope.row.uploadMainImages" :key="item">-->
<!--                <img :src="item" width="100" height="100"/>-->
<!--              </el-carousel-item>-->
<!--            </el-carousel>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="uploadMainImages" label="图片">
          <template scope="scope">
                <img :src="scope.row.uploadMainImages[0]" width="100" height="100"/>
          </template>
        </el-table-column>
        <el-table-column prop="shopId" label="店铺ID"></el-table-column>
        <el-table-column prop="shopKeeper" label="店铺掌柜"></el-table-column>
        <el-table-column prop="shopLocation" label="店铺所在地"></el-table-column>
        <el-table-column prop="shopGoodsCount" label="店铺商品数"></el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
// const _ = require("lodash");
export default {
  name: "searchSiteAdvInfo",
  data() {
    return {
      advs: [],
      keyword: "",
      authorNickname: "",
      authorDouId: "",
      whether: null,
      videoTitle: "",
      crawlerVersion: null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
      dataScope: '只看新增'
    };
  },
  methods: {
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      if(this.dataScope === '只看新增') {
        para += "&scope=1" ;
      }

      window.open("/api/tiktok/export/items?" + para);
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword.replace('+','%2B');
      }

      if(this.dataScope === '只看新增') {
        para += "&scope=1" ;
      }


      axios
          .get("/api/tiktok/goods/queryPage?currentPage=" + pageNum + "&pageSize=50" + para)
          .then((content) => {
            if (content.data.status === 0) {
              console.log(content.data.data)
              _this.advs = content.data.data;
              _this.totalItems = content.data.total;
            }
          });
    },
  },
  mounted() {
    this.loadItemInfo(1);
  },
};
</script>
